import { render, staticRenderFns } from "./TotalTransactionDataPannel.vue?vue&type=template&id=1df57558&scoped=true"
import script from "./TotalTransactionDataPannel.vue?vue&type=script&lang=js"
export * from "./TotalTransactionDataPannel.vue?vue&type=script&lang=js"
import style0 from "./TotalTransactionDataPannel.vue?vue&type=style&index=0&id=1df57558&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df57558",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1df57558')) {
      api.createRecord('1df57558', component.options)
    } else {
      api.reload('1df57558', component.options)
    }
    module.hot.accept("./TotalTransactionDataPannel.vue?vue&type=template&id=1df57558&scoped=true", function () {
      api.rerender('1df57558', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ezpay/dashboard/components/TotalTransactionDataPannel.vue"
export default component.exports